import { lazy } from 'react'
const Index = lazy(() => import('./pages/index'))
const Home = lazy(() => import('./pages/index/home/Home'))
const About = lazy(() => import('./pages/index/about/About'))
const Product = lazy(() => import('./pages/index/product/Product'))
const Search = lazy(() => import('./pages/index/product/Search'))
const Detail = lazy(() => import('./pages/index/product/Detail'))
const Tips = lazy(() => import('./pages/index/tips/Tips'))
const TipsDetail = lazy(() => import('./pages/index/tips/Detail'))
const Contact = lazy(() => import('./pages/index/contact/Contact'))

const Moblie = lazy(() => import('./pages/mobile'))
const MoblieHome = lazy(() => import('./pages/mobile/home'))
const MoblieAbout = lazy(() => import('./pages/mobile/about'))
const MoblieProduct = lazy(() => import('./pages/mobile/product'))
const MobileDetail = lazy(() => import('./pages/mobile/product/Detail'))
const MoblieTips = lazy(() => import('./pages/mobile/tips'))
const MobileTipsDetail = lazy(() => import('./pages/mobile/tips/Detail'))
const MoblieCart = lazy(() => import('./pages/mobile/cart'))
const MoblieConfirm = lazy(() => import('./pages/mobile/confirm'))
const MoblieContact = lazy(() => import('./pages/mobile/contact'))

const Manage = lazy(() => import('./pages/manage'))
const ManageHome = lazy(() => import('./pages/manage/home'))
const UserList = lazy(() => import('./pages/manage/user'))
const InformationList = lazy(() => import('./pages/manage/information'))
const CarouselList = lazy(() => import('./pages/manage/carousel'))
const CategoryList = lazy(() => import('./pages/manage/category'))
const ProductList = lazy(() => import('./pages/manage/product'))
const ContactList = lazy(() => import('./pages/manage/contact'))
const TipsList = lazy(() => import('./pages/manage/tips'))
const OrderList = lazy(() => import('./pages/manage/order'))
const FeedbackList = lazy(() => import('./pages/manage/feedback'))
const BrandList = lazy(() => import('./pages/manage/brand'))
const CertList = lazy(() => import('./pages/manage/cert'))
const Login = lazy(() => import('./pages/login'))

const routes =
  [
    {
      path: '/',
      element: <Index />,
      children: [
        {
          index: true,
          element: <Home />
        },
        {
          path: 'about',
          element: <About />
        },
        {
          path: 'product/:id',
          element: <Product />
        },
        {
          path: 'detail/:id',
          element: <Detail />
        },
        {
          path: 'search',
          element: <Search />
        },
        {
          path: 'tips/:id',
          element: <TipsDetail />
        },
        {
          path: 'tips',
          element: <Tips />
        },
        {
          path: 'contact',
          element: <Contact />
        }
      ]
    },
    {
      path: 'mobile',
      element: <Moblie />,
      children: [{
        index: true,
        element: <MoblieHome />
      },
      {
        path: 'about',
        element: <MoblieAbout />
      },
      {
        path: 'product/:id',
        element: <MoblieProduct />
      },
      {
        path: 'detail/:id',
        element: <MobileDetail />
      },
      {
        path: 'tips/:id',
        element: <MobileTipsDetail />
      },
      {
        path: 'tips',
        element: <MoblieTips />
      },
      {
        path: 'cart',
        element: <MoblieCart />
      },
      {
        path: 'confirm',
        element: <MoblieConfirm />
      },
      {
        path: 'contact',
        element: <MoblieContact />
      }]
    },
    {
      path: '/manage/login',
      element: <Login />
    },
    {
      path: 'manage',
      element: <Manage />,
      children: [
        {
          index: true,
          element: <ManageHome />
        },
        {
          path: 'userlist',
          element: <UserList />
        },
        {
          path: 'information',
          element: <InformationList />
        },
        {
          path: 'category',
          element: <CategoryList />
        },
        {
          path: 'product',
          element: <ProductList />
        },
        {
          path: 'carousel',
          element: <CarouselList />
        },
        {
          path: 'contact',
          element: <ContactList />
        },
        {
          path: 'tips',
          element: <TipsList />
        },
        {
          path: 'order',
          element: <OrderList />
        },
        {
          path: 'feedback',
          element: <FeedbackList />
        },
        {
          path: 'brand',
          element: <BrandList />
        },
        {
          path: 'cert',
          element: <CertList />
        },
      ]
    },
  ]

export default routes